import React from 'react'
import styled from 'styled-components'
import { Box, BoxType } from '../box'

export interface Props extends Omit<BoxType, 'size'> {
  icon: React.ComponentType
  size?: 3 | 4 | 5 | 6
  UNSAFE_hexColor?: string
}

export const Icon = ({ size = 4, icon: Icon, UNSAFE_hexColor, ...props }: Props) => {
  return (
    <IconWrapper w={size} h={size} UNSAFE_hexColor={UNSAFE_hexColor} {...props}>
      <Icon />
    </IconWrapper>
  )
}

const IconWrapper = styled(Box)<{ UNSAFE_hexColor?: string }>`
  color: ${({ UNSAFE_hexColor }) => UNSAFE_hexColor};
`
